<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="ack"><span class="epub-b">ACKNOWLEDGMENTS</span></p>
<p class="tni">M<span class="epub-sc">ANY</span> thanks to our literary manager, Peter Miller of PMA Literary and Film Management Agency, for his tireless efforts in finding the best publisher for our work. We greatly appreciate the sensitivities and support offered our project by our editor, George Witte, and his principal assistant, Marie Estrada, as well as the efforts of Henry Yee, who created the graphics.</p>
<p class="tx">We are also indebted to Julie Wheelock for her work in transcribing dozens of interview tapes both rapidly and accurately. Retired Foreign Service Officer Douglas Pike was generous with his time and personal recollections. Dr. James R. Reckner and Dr. Ron Frankum of Texas Tech University provided several photos and allowed us access to much helpful historical material.</p>
<p class="tx">Archivist Mike Parrish of the Lyndon Baines Johnson Library in Austin, Texas, was especially helpful in locating declassified documents from the LBJ era.</p>
<p class="tx">John Taylor and Susan Naulty of the Richard M. Nixon Presidential Library in Brea, California, were courteous and most helpful in offering records and photos of Mr. Nixon’s post-presidential contacts with General Ky.</p>
<p class="tx">Joseph and Barbara Treaster graciously offered the hospitality of their home during several visits to New York in connection with this book.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?69183b32